import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import { get } from "react-hook-form";
import type { SelectValueProp } from "./system.types";
import { SELECT_DEFAULT_VALUE_PROP } from "src/system/constants.ts";

export const getSelectValue = <
  Resource extends GridValidRowModel = GridValidRowModel,
>({
  item,
  valueProp,
}: {
  item: Resource;
  valueProp?: SelectValueProp<Resource>;
}) => {
  if (typeof valueProp === "function") {
    return valueProp(item);
  }
  return get(item, valueProp ?? SELECT_DEFAULT_VALUE_PROP);
};
